import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table, Alert } from "react-bootstrap";
import C from '../lib/Config';

export default class MultipleTreatmentPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientId: this.props.patientId,
            treatmentPlanDetails: [],
            selectedTreatmentPlanId: [],
            selectedProtocolId: [],
            cascadeTreatmentPlanId: [],
            confirmation: 'NA',
            consentGiven: false,
            showWarning: false,
            warningMsgConsent:'',
        };
        this.checkboxChange = this.checkboxChange.bind(this);
        this.cascadeTreatChange = this.cascadeTreatChange.bind(this);
        this.handleConsentChange = this.handleConsentChange.bind(this);
    }

    formatDateMMDDYY(date) {
        if (date !== undefined && date !== "") {
            var dateTypeformate = (new Date(date)).toISOString().split('T')[0];
            return dateTypeformate;
        }
        return "";
    }

    getTreatmentDataForNewChemo(patientId) {
        return fetch(C.getUrl() + '/userCase/getTreatmentDataForNewChemo?patientId=' + patientId)
            .then(res => res.json())
            .then(res => {
                const details = (res.message && res.message !== 'NO_DATA') ? JSON.parse(res.message) : [];
                this.setState({ selectedTreatmentPlanId: [], selectedProtocolId: [], treatmentPlanDetails: details });
            })
            .catch(err => {
                console.log("Error : " + err);
            });
    }

    checkboxChange(event) {
        const myArray = event.target.value.split("$");
        if (event.target.checked) {
            if (!this.state.selectedTreatmentPlanId.includes(myArray[0]) && !this.state.selectedProtocolId.includes(myArray[1])) {
                this.setState(prevState => ({
                    selectedTreatmentPlanId: prevState.selectedTreatmentPlanId.concat(myArray[0]),
                    selectedProtocolId: prevState.selectedProtocolId.concat(myArray[1])
                }), this.checkConsentRequirement);
            }
        } else {
            this.setState(prevState => ({
                selectedTreatmentPlanId: prevState.selectedTreatmentPlanId.filter(id => id !== myArray[0]),
                selectedProtocolId: prevState.selectedProtocolId.filter(id => id !== myArray[1])
            }), this.checkConsentRequirement);
        }
    }

    cascadeTreatChange(event) {
        let treatPlanId = event.target.value;
        if (event.target.checked) {
            if (!this.state.cascadeTreatmentPlanId.includes(treatPlanId)) {
                this.setState(prevState => ({
                    cascadeTreatmentPlanId: prevState.cascadeTreatmentPlanId.concat(treatPlanId)
                }));
            }
        } else {
            this.setState(prevState => ({
                cascadeTreatmentPlanId: prevState.cascadeTreatmentPlanId.filter(id => id !== treatPlanId)
            }));
        }
    }

    handleConsentChange(event) {
        const consentGiven = event.target.checked;
        this.setState({
            consentGiven: consentGiven,
            showWarning: !consentGiven,
            warningMsgConsent: consentGiven ? 'Y' : 'NA'
        });
    }

    checkConsentRequirement() {
        const terminationMessages = [
            'Patient consent not received',
            'No report exists from Treatment creation Date',
            'Biochemistry(Serum Creatinine)',
            'CBC(Hemoglobin,ANC,Platelet)'
        ];
        const requiresConsent = this.state.treatmentPlanDetails.some(detail =>
            this.state.selectedTreatmentPlanId.includes(detail.patientTreatmentPlanId.toString()) &&
            detail.terminationMsg &&
            !terminationMessages.includes(detail.terminationMsg)
        );
        this.setState({ showWarning: requiresConsent && !this.state.consentGiven });
    }

    confirm() {
        if (this.state.selectedTreatmentPlanId.length && this.state.selectedProtocolId.length) {
            console.log(this.state.selectedTreatmentPlanId + '##' + this.state.selectedProtocolId);
            this.props.closeModal();
            this.props.multipleTreatmentSavedSuccess(this.state.selectedTreatmentPlanId, this.state.selectedProtocolId, this.state.cascadeTreatmentPlanId, this.state.warningMsgConsent);
            this.setState({ selectedTreatmentPlanId: [], selectedProtocolId: [], cascadeTreatmentPlanId: [], consentGiven: false, showWarning: false });
        } else {
            alert("Please select at least one Treatment Plan.");
        }
    }

    formatDateDDMMYYYY(date) {
        if (date !== undefined && date !== "") {
            var dateObj = new Date(date);
            var day = String(dateObj.getDate()).padStart(2, '0');
            var month = String(dateObj.getMonth() + 1).padStart(2, '0');
            var year = dateObj.getFullYear();
            return `${day}-${month}-${year}`;
        }
        return "";
    }

    formatDateDDMonYYYY(date) {
        if (date !== undefined && date !== "") {
            const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            var dateObj = new Date(date);
            var day = String(dateObj.getDate()).padStart(2, '0');
            var month = months[dateObj.getMonth()];
            var year = dateObj.getFullYear();
            return `${day}-${month}-${year}`;
        }
        return "";
    }

    render() {
        const { showMultipleTreatmentPopup, closeModal } = this.props;
        const closePreviewModal = () => {
            this.setState({ selectedTreatmentPlanId: [], selectedProtocolId: [], cascadeTreatmentPlanId: [], consentGiven: false, showWarning: false });
            closeModal();
        }

        const terminationMessages = [
            'Patient consent not received',
            'No report exists from Treatment creation Date',
            'Biochemistry(Serum Creatinine)',
            'CBC(Hemoglobin,ANC,Platelet)'
        ];

        const shouldRequireConsent = this.state.treatmentPlanDetails.some(detail =>
            detail.terminationMsg && !terminationMessages.includes(detail.terminationMsg)
        );

        const terminationMessageList = this.state.treatmentPlanDetails
            .map(detail => detail.terminationMsg)
            .filter(msg => msg && !terminationMessages.includes(msg))
            .join(', ');

        return (
            <Modal id="" show={showMultipleTreatmentPopup} centered animation={true} scrollable={true} size="lg">
                <Modal.Header closeButton onClick={() => closePreviewModal()}>
                    <Modal.Title>
                        <h3 className="fs-18 header_title mb-0 text-black">Protocols/Treatment Plans</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid>
                        <Row>
                            <Col lg='12'>
                                {this.state.treatmentPlanDetails.length ? (
                                    <Table hover responsive="sm" id="multipleChemoTable">
                                        <thead className='thead-light'>
                                            <tr>
                                                <th>#</th>
                                                <th className="text-center">Treatment Name</th>
                                                <th className="text-center">Previous Cycle Date</th>
                                                <th className="text-center">Coming Cycle Date</th>
                                                <th className="text-center">Cascade change in Schedule</th>
                                                <th className="text-center">Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.treatmentPlanDetails.map((d, idx) => {
                                                const isGrayOut = terminationMessages.includes(d.terminationMsg);
                                                const rowClass = isGrayOut ? 'disabled-even' : 'disabled-odd';
                                                const rowStyle = isGrayOut ? { color: 'gray' } : {};

                                                return (
                                                    <tr key={idx} role="row" className={rowClass} style={rowStyle}>
                                                        <td>
                                                            <Form.Check
                                                                type="checkbox"
                                                                className="pl-0"
                                                                value={d.patientTreatmentPlanId + '$' + d.protocolId}
                                                                onChange={this.checkboxChange}
                                                                disabled={isGrayOut}
                                                            />
                                                        </td>
                                                        <td>{d.protocolName}</td>
                                                        <td>{d.previousCycleDate !== 'NA' ? this.formatDateDDMonYYYY(d.previousCycleDate) : d.previousCycleDate}</td>
                                                        <td>{d.comingCycleDate !== 'NA' ? this.formatDateDDMonYYYY(d.comingCycleDate) : d.comingCycleDate}</td>
                                                        <td>
                                                            <Form.Check
                                                                type="checkbox"
                                                                className="pl-0"
                                                                value={d.patientTreatmentPlanId}
                                                                onChange={this.cascadeTreatChange}
                                                                disabled={d.comingCycleDate === 'NA' || this.formatDateDDMMYYYY(d.comingCycleDate) === this.formatDateDDMMYYYY(new Date())}
                                                            />
                                                        </td>
                                                        <td>{d.terminationMsg}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <div><h3>Please add treatment plan.</h3></div>
                                )}
                            </Col>
                        </Row>
                        {shouldRequireConsent && terminationMessageList && (
                            <Row className="mt-3">
                                <Col lg='12' className="text-center">
                                    <Form.Check
                                        inline
                                        type="checkbox"
                                        onChange={this.handleConsentChange}
                                    />
                                    <span>I agree with the above warning </span>
                                </Col>
                            </Row>
                        )}
                        {this.state.showWarning && (
                            <Row className="mt-3">
                                <Col lg='12' className="text-center">
                                    <Alert variant="warning">
                                        Please check the "I agree" checkbox to proceed.
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                    </Container>
                </Modal.Body>
                <Modal.Footer className='text-center'>
                    <Button className="btn btn-secondary" onClick={() => this.confirm()} disabled={shouldRequireConsent && !this.state.consentGiven}>
                        {this.state.saveLoader && (
                            <Spinner className='mr-2' animation='border' size='1.5rem' />
                        )}
                        Continue
                    </Button>
                    <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}
